import { uploadFile } from '@/lib/upload-file';

// Tenant logo upload.
//
// GitHub #270: the upload must be checked for an HTTP error. fetch() only
// rejects on a network-level failure — an HTTP 403/404/500 resolves normally,
// so without inspecting res.ok the caller would commit a logo_url that points
// to an object that was never stored. Throwing here makes the upload surface a
// real error instead of a false "Logo uploaded" success. `uploadFile` keeps
// that contract, and adds server-side compression plus a 1MB stored ceiling.
//
// The presign indirection this used to take (`getPresignedUploadUrl`) is gone:
// the browser no longer PUTs to S3 itself, so there is no URL to fetch first.

export type LogoContentType = 'image/png' | 'image/jpeg' | 'image/webp' | 'application/pdf';

export async function uploadTenantLogo(
  file: File,
  fetchFn: typeof fetch = fetch,
): Promise<string> {
  const { file_url } = await uploadFile(file, 'tenant-logo', fetchFn);
  return file_url;
}
